import { PaymentCard } from "../../components/_new/payment/paymentCard";
import { Switcher } from "../../components/_new/switcher";
import { toast } from "../../components/message";
import { store, storeOrder } from "../../mobile";
import { alteraDadosUsuario, usuario } from "../../usuario";
import { buttonLoader, createElement, createMessageBox, detectCard, enableSaveOrderButton, formatMoney, getUrlAction, ripple } from "../../utils";
import { estabelecimento } from "../estabelecimento";
import { carregaCartoesMalgaSalvos, ocultaCartaoMalga } from "../../Malga/malgaHelpers";
import { abreFormCartaoMalga } from "../../Malga/malgaTokenizationForm";
import {
  PREFIXO_MOGOPAY_CREDITO,
  PREFIXO_MOGOPAY_PIX,
  bandeiraSicredi,
  buscaMetodoCreditoOnline,
  buscaMetodoPixOnline,
} from "../../Malga/mogoPay";

export function formasPagamento(container, onChangePaymentMethod) {
  let selectedPaymentMethod = null;

  const metodoDinheiro = estabelecimento.pagamento.metodos.find(item => item.Prefixo == "DIN" && item.ExibirDelivery);
  const metodoCartaoCredito = estabelecimento.pagamento.metodos.find(item => item.Prefixo == "CRCR");
  const metodoCartaoDebito = estabelecimento.pagamento.metodos.find(item => item.Prefixo == "CRDE");
  // O PIX cobrado pelo app é o MogoPay (PMPY, via Malga) ou um PIX com integrador
  // no banco (Sicredi); o PIX pago na entrega/retirada é outro cadastro (ou o
  // mesmo, no caso do integrador — e aí só pixNaEntrega distingue os dois fluxos).
  const metodosPIX = estabelecimento.pagamento.metodos.filter(item => item.Prefixo == "PIX");
  const metodoPIXOnline = buscaMetodoPixOnline(estabelecimento.pagamento.metodos);
  const metodoPIXEntrega = metodosPIX.find(item => item.ExibirDelivery);
  const outrosTiposPagamento = estabelecimento.pagamento.metodos.filter(item =>
    !['DIN', 'CRDE', 'CRCR', 'PIX', 'OLON', PREFIXO_MOGOPAY_PIX, PREFIXO_MOGOPAY_CREDITO].includes(item.Prefixo) && item.ExibirDelivery
  )

  const utilizaIntegracaoPagarme = estabelecimento.utilizaIntegracaoPagarme;
  const utilizaPixOnline = !!metodoPIXOnline;
  // Cartão de crédito pelo app é sempre Malga (MogoPay - Crédito).
  const metodoPagamentoOnlineCredito = buscaMetodoCreditoOnline(estabelecimento.pagamento.metodos);
  const usaPagamentoOnline = utilizaPixOnline || metodoPagamentoOnlineCredito

  // Get all payment methods for pre-selection logic
  const allPaymentMethods = [
    metodoDinheiro,
    metodoCartaoCredito,
    metodoPagamentoOnlineCredito,
    metodoCartaoDebito,
    // O PIX do app pode ser o MogoPay (PMPY), que não está em metodosPIX.
    metodoPIXOnline,
    ...metodosPIX,
    ...outrosTiposPagamento
  ].filter(Boolean); // Filter out undefined methods

  // Find the pre-selected method based on storeOrder.CodTipoPagamento
  let preSelectedMethodId = storeOrder.CodTipoPagamento;
  let preSelectedMethod = preSelectedMethodId ? allPaymentMethods.find(method => method.Id === preSelectedMethodId) : null;

  // Determine which tab should be active initially
  let initialActiveTab = 0;
  if (preSelectedMethod) {

    enableSaveOrderButton();

    // If preSelectedMethod is online (PIX or credit card with hashCard)
    // storeOrder.pixNaEntrega desempata quando o mesmo cadastro de PIX serve às duas abas.
    if ((preSelectedMethod == metodoPIXOnline && !storeOrder.pixNaEntrega) ||
      (preSelectedMethod == metodoPagamentoOnlineCredito && (storeOrder.hashCard || storeOrder.malgaCardId || storeOrder.malgaTokenId) && metodoPagamentoOnlineCredito)) {
      initialActiveTab = 0; // "Pague pelo app" tab
    } else {

      if (!usaPagamentoOnline) {
        initialActiveTab = 0
      } else {
        initialActiveTab = 1; // "Pague na entrega" tab
      }
    }
  }

  usuario.cartoesMalga = usuario.cartoesMalga || [];

  function createOnlinePaymentContent() {
    // Lista vertical para cartões Malga salvos (suporta apelidos longos)
    const malgaCardsContainer = createElement('div', { class: 'flex-column' });

    // Rolagem horizontal para PIX, cartões legados e botão de adicionar
    const onlinePaymentContainer = createElement('div', { class: 'flex gap-16 py-16 overflow-auto' });

    if (utilizaPixOnline) {
      const pixCard = new PaymentCard({
        id: metodoPIXOnline.Id,
        name: 'Pix',
        subtitle: 'Transferência instantânea',
        imagePath: `${location.origin}/images/pagamentos/pix.svg`,
        isSelected: storeOrder.CodTipoPagamento == metodoPIXOnline.Id && !storeOrder.pixNaEntrega,
        onClick: () => {
          storeOrder.pixNaEntrega = false
          removeCurrentSelected();
          pixCard.setSelected(true);
          selectedPaymentMethod = metodoPIXOnline;

          onClickPix(metodoPIXOnline.Id);
        }
      });

      if (storeOrder.CodTipoPagamento == metodoPIXOnline.Id && !storeOrder.pixNaEntrega) {
        selectedPaymentMethod = metodoPIXOnline;
      }

      pixCard.mount(onlinePaymentContainer);
    }

    if (metodoPagamentoOnlineCredito) {
      if (usuario.cartoesMalga && usuario.cartoesMalga.length > 0) {
        usuario.cartoesMalga.forEach((cartao, index) => {
          const isTemp = cartao.temporary || cartao.cardId === '__malga_token__';
          const isSelected = isTemp
            ? !!storeOrder.malgaTokenId
            : storeOrder.malgaCardId === cartao.cardId;
          const card = new PaymentCard({
            id: cartao.cardId,
            name: isTemp ? 'Novo cartão' : (cartao.alias || cartao.brand || 'Cartão de crédito'),
            subtitle: isTemp ? 'Será usado nesta compra' : (cartao.alias ? `${cartao.brand || ''} · **** ${cartao.last4}` : `**** **** **** ${cartao.last4}`),
            imagePath: generateCardSVG(index % 6),
            isSelected,
            isVertical: true,
            onRemove: !isTemp ? () => {
              ocultaCartaoMalga(cartao.cardId);
              usuario.cartoesMalga = usuario.cartoesMalga.filter((item) => item.cardId !== cartao.cardId);
              if (storeOrder.malgaCardId === cartao.cardId) {
                storeOrder.malgaCardId = '';
                storeOrder.CodTipoPagamento = '';
              }
              toast('Cartão removido da lista.', 'success');
              refreshPaymentCards();
            } : null,
            onClick: () => {
              removeCurrentSelected();
              selectedPaymentMethod = metodoPagamentoOnlineCredito;
              card.setSelected(true);

              storeOrder.CodTipoPagamento = metodoPagamentoOnlineCredito.Id;
              storeOrder.hashCard = '';
              storeOrder.cartao = undefined;
              // Limpa sobra de uma escolha de PIX anterior — senão o pedido ainda
              // era tratado como PIX na hora de salvar (gerava o QR Code).
              storeOrder.pixNaEntrega = false;

              if (isTemp) {
                storeOrder.malgaCardId = '';
              } else {
                storeOrder.malgaCardId = cartao.cardId;
                storeOrder.malgaTokenId = '';
              }

              enableSaveOrderButton();
            }
          });

          if (isSelected) {
            selectedPaymentMethod = metodoPagamentoOnlineCredito;
          }

          card.mount(malgaCardsContainer);
        });
      }

      if (usuario.cartoes && usuario.cartoes.length > 0) {
        usuario.cartoes.forEach((cartao, index) => {
          index = index % 6;

          const card = new PaymentCard({
            id: cartao.LastFourDigits,
            name: 'Cartão de crédito',
            subtitle: `**** **** **** ${cartao.LastFourDigits}`,
            imagePath: generateCardSVG(index),
            isSelected: storeOrder.hashCard === cartao.HashCard,
            onClick: () => {
              removeCurrentSelected();
              selectedPaymentMethod = metodoPagamentoOnlineCredito;
              card.setSelected(true);

              if (cartao.HashCard.includes('novo-cartao')) {
                const novoCartao = usuario.cartoes.find(
                  (item) => item.HashCard == cartao.HashCard,
                );
                storeOrder.cartao = novoCartao.raw;
                storeOrder.CodTipoPagamento = novoCartao.raw.codTipoPagamento;
                storeOrder.ClienteCpf = novoCartao.raw.clienteCpf;
                storeOrder.saveCard = novoCartao.raw.saveCard;
              } else {
                storeOrder.hashCard = cartao.HashCard;
                storeOrder.malgaCardId = '';
                storeOrder.malgaTokenId = '';
                storeOrder.CodTipoPagamento = metodoPagamentoOnlineCredito.Id;
              }

              enableSaveOrderButton();
            }
          });

          if (storeOrder.hashCard === cartao.HashCard) {
            selectedPaymentMethod = metodoPagamentoOnlineCredito;
          }

          card.mount(onlinePaymentContainer);
        });
      }

      //Adicionar novo cartão
      const addNewCardButton = new PaymentCard({
        id: 'add-new-card',
        name: '<span class="font-10-5">Adicionar cartão</span>',
        variant: 'blue',
        imagePath: `
        <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 7H28V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V7Z" fill="#4962F1"/>
        <path d="M0 2C0 0.89543 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V7H0V2Z" fill="#4962F1" fill-opacity="0.18"/>
        <path d="M26.5 24C29.5376 24 32 21.5376 32 18.5C32 15.4624 29.5376 13 26.5 13C23.4624 13 21 15.4624 21 18.5C21 21.5376 23.4624 24 26.5 24Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.0312 18.5C22.0312 16.032 24.032 14.0312 26.5 14.0312C28.9681 14.0312 30.9688 16.032 30.9688 18.5C30.9688 20.9681 28.9681 22.9688 26.5 22.9688C24.032 22.9688 22.0312 20.9681 22.0312 18.5ZM26.5 13C23.4624 13 21 15.4624 21 18.5C21 21.5376 23.4624 24 26.5 24C29.5376 24 32 21.5376 32 18.5C32 15.4624 29.5376 13 26.5 13ZM27.0156 16.2656C27.0156 15.9809 26.7848 15.75 26.5 15.75C26.2152 15.75 25.9844 15.9809 25.9844 16.2656V17.9844H24.2656C23.9809 17.9844 23.75 18.2152 23.75 18.5C23.75 18.7848 23.9809 19.0156 24.2656 19.0156H25.9844V20.7344C25.9844 21.0191 26.2152 21.25 26.5 21.25C26.7848 21.25 27.0156 21.0191 27.0156 20.7344V19.0156H28.7344C29.0191 19.0156 29.25 18.7848 29.25 18.5C29.25 18.2152 29.0191 17.9844 28.7344 17.9844H27.0156V16.2656Z" fill="#4962F1"/>
        </svg>
        `,
        onClick: () => {
          addNewCard(container, refreshPaymentCards);
        }
      });

      addNewCardButton.mount(onlinePaymentContainer);
    }

    let extraAddButton
    if (usuario.cartoes && usuario.cartoes.length > 2) {
      extraAddButton = createElement('button', { class: 'btn-transparent py-16 text-center' }, "Adicionar novo cartão");
      ripple(extraAddButton);
      extraAddButton.addEventListener('click', () => {
        addNewCard(container, refreshPaymentCards);
      });
    }

    const children = [];
    if (malgaCardsContainer.children.length > 0) children.push(malgaCardsContainer);
    children.push(onlinePaymentContainer);
    if (extraAddButton) children.push(extraAddButton);

    return createElement('div', { class: 'flex-column gap-8 py-8' }, children);
  }

  function createDeliveryPaymentContent() {
    const deliveryPaymentContainer = createElement('div', { class: 'flex-column gap-16 py-16' });

    // Add payment methods for delivery
    function addPaymentMethod(method, label, iconPath, type = "offline") {
      // Quando o mesmo cadastro de PIX atende as duas abas, só pixNaEntrega diz qual card está marcado.
      const isPreSelected = storeOrder.CodTipoPagamento == method.Id &&
        (method.Prefixo !== 'PIX' || method !== metodoPIXOnline || !!storeOrder.pixNaEntrega);

      // For cash method, check if we need to display troco info
      let subtitle = method.Descricao;
      let personalizedContent = '';
      if (method.Prefixo === 'DIN' && storeOrder.TrocoDelivery) {
        personalizedContent = `
        <div class="flex-column font-10-5 font-500">
          <span class="w-m-c" style="margin-left: auto;">Troco para </span>
          <span>${formatMoney(storeOrder.TrocoDelivery.parseNumber())}</span>
          </div>
        `;
      }

      if ((method.Prefixo === 'CRDE' || method.Prefixo === 'CRCR') && storeOrder.CodBandeiraCartaoDelivery) {

        const selectedBrand = method.Bandeiras.find(brand => brand.Bandeira.Id == storeOrder.CodBandeiraCartaoDelivery);
        console.log(storeOrder)

        if (selectedBrand) {
          personalizedContent = `
          <div class="flex flex-center gap-4">
            <img 
              style="width: 16px; height: 16px;"
              src="${location.origin}/images/pagamentos/${selectedBrand.Bandeira.StrTipoBandeira.toLowerCase()}.svg" 
              alt="${selectedBrand.Bandeira.Descricao}" 
              onerror="this.src='${location.origin}/images/pagamentos/outros.svg'"
            >
            <span class="font-12 font-600">${selectedBrand.Bandeira.Descricao}</span>
          </div>
        `
        }
      }

      const paymentCard = new PaymentCard({
        id: method.Id,
        name: label,
        subtitle: subtitle,
        imagePath: iconPath,
        isSelected: isPreSelected,
        isVertical: true,
        personalizedContent,
        onClick: () => {
          if (method.Prefixo === 'CRDE' || method.Prefixo === 'CRCR') {
            // For credit and debit cards, show brands dialog
            showBrandsDialog(method, paymentCard);
          } else {

            storeOrder.pixNaEntrega = method.Prefixo == "PIX"
            // For other payment methods, proceed as before
            removeCurrentSelected();
            paymentCard.setSelected(true);
            selectedPaymentMethod = method;
            storeOrder.CodTipoPagamento = method.Id;
            storeOrder.CodBandeiraCartaoDelivery = '';
            limpaCartaoOnline();

            // If it's cash payment, show troco dialog
            if (method.Prefixo === 'DIN') {
              showTrocoDialog(method, paymentCard);
            } else {
              enableSaveOrderButton();
            }
          }
        }
      });

      if (isPreSelected) {
        selectedPaymentMethod = method;
        storeOrder.CodTipoPagamento = method.Id;
      }

      paymentCard.mount(deliveryPaymentContainer);
    }

    if (metodoDinheiro && metodoDinheiro.ExibirDelivery) {
      addPaymentMethod(metodoDinheiro, 'Dinheiro', `${location.origin}/images/pagamentos/dinheiro.svg`);
    }

    if (metodoCartaoDebito && metodoCartaoDebito.ExibirDelivery) {
      addPaymentMethod(metodoCartaoDebito, 'Cartão de Débito', generateCardSVG(1));
    }

    if (metodoCartaoCredito && metodoCartaoCredito.ExibirDelivery) {
      addPaymentMethod(metodoCartaoCredito, 'Cartão de Crédito', generateCardSVG(0));
    }

    if (metodoPIXEntrega) {
      addPaymentMethod(metodoPIXEntrega, 'Pix', `${location.origin}/images/pagamentos/pix.svg`);
    }

    // Add other payment methods
    outrosTiposPagamento.forEach((method, index) => {

      // Escolhe um índice entre 2 e 5 de acordo com o index
      let normalizedIndex = index % 5;
      let result;

      if (normalizedIndex === 0) result = 2;
      else if (normalizedIndex === 1) result = 3;
      else if (normalizedIndex === 2) result = 4;
      else if (normalizedIndex === 3) result = 5;
      else if (normalizedIndex === 4) result = 2;

      addPaymentMethod(method, method.Descricao, generateCardSVG(result));
    });

    return deliveryPaymentContainer;
  }

  const switcherTabs = []

  if (utilizaPixOnline || metodoPagamentoOnlineCredito) {
    switcherTabs.push({
      label: `
            <svg width="18" height="18" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.55 1.3999H3.15C2.37681 1.3999 1.75 2.02671 1.75 2.7999V18.1999C1.75 18.9731 2.37681 19.5999 3.15 19.5999H11.55C12.3232 19.5999 12.95 18.9731 12.95 18.1999V2.7999C12.95 2.02671 12.3232 1.3999 11.55 1.3999Z" stroke="currentcolor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.75 4.8999C6.12387 4.8999 8.57613 4.8999 12.95 4.8999" stroke="currentcolor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.75 16.1001H12.95" stroke="currentcolor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Pague pelo app`,
      content: createOnlinePaymentContent()
    })
  }


  if ((metodoDinheiro && metodoDinheiro.ExibirDelivery) ||
    (metodoCartaoDebito && metodoCartaoDebito.ExibirDelivery) ||
    (metodoCartaoCredito && metodoCartaoCredito.ExibirDelivery) ||
    (outrosTiposPagamento.length > 0 && outrosTiposPagamento.some(item => item.ExibirDelivery)) ||
    metodoPIXEntrega
  ) {

    let label = `
    Pague na entrega
    <svg width="18" height="18" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.5457 14.4062L13.6831 11.9424V9.09302L18.5457 9.70901V14.4062Z" stroke="currentColor" stroke-width="1.4"/>
      <path d="M11.4608 8.08206C11.1339 8.0508 10.8716 8.29332 10.8716 8.60917V10.9988C10.8716 11.2016 10.9827 11.3837 11.1613 11.474L11.9201 11.8584V8.14023L11.4608 8.08206Z" fill="currentColor"/>
      <path d="M14.969 2.61049C12.9205 1.21803 10.3256 0.798987 7.90923 1.47157C6.35204 1.90444 4.88918 3.01972 3.81069 4.50042C2.73305 5.97999 2.07959 7.76944 2.07959 9.48974V12.0339C2.07959 12.365 2.26956 12.6768 2.58943 12.8287L14.1535 17.6594L14.1548 17.6599C15.2858 18.1348 16.5913 17.6382 17.1264 16.4936L10.3733 13.072C9.59854 12.6794 9.10908 11.8769 9.10908 10.9992V8.60931C9.10908 7.20248 10.3332 6.13456 11.6812 6.30999L11.6827 6.31017L18.2544 7.14267C17.7183 5.33186 16.569 3.69804 14.969 2.61049ZM14.969 2.61049L14.757 2.74452" stroke="currentColor" stroke-width="1.4"/>
    </svg>`

    if (estabelecimento.entrega.somenteEntregaBalcao || storeOrder.CodObsEntrega == estabelecimento.codigoBuscaBalcao) {
      label = `
      Pague na retirada
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-hand-platter-icon lucide-hand-platter"><path d="M12 3V2"/><path d="m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5"/><path d="M2 14h12a2 2 0 0 1 0 4h-2"/><path d="M4 10h16"/><path d="M5 10a7 7 0 0 1 14 0"/><path d="M5 14v6a1 1 0 0 1-1 1H2"/></svg>`
    }

    switcherTabs.push({
      label: label,
      content: createDeliveryPaymentContent()
    })
  }

  const switcher = new Switcher(container, switcherTabs, onChangePaymentMethod);

  if (metodoPagamentoOnlineCredito && !usuario.cartoesMalgaCarregados && !usuario.cartoesMalgaCarregando) {
    usuario.cartoesMalgaCarregando = true;
    carregaCartoesMalgaSalvos().then((cards) => {
      usuario.cartoesMalga = cards || [];
      usuario.cartoesMalgaCarregados = true;
      usuario.cartoesMalgaCarregando = false;
      refreshPaymentCards();
    });
  }

  // Set the initial active tab based on preselection
  if (initialActiveTab !== 0) {
    switcher.switchTab(initialActiveTab);
  }

  function refreshPaymentCards() {


    if (selectedPaymentMethod && selectedPaymentMethod.Prefixo != 'DIN' && storeOrder.TrocoDelivery) {
      storeOrder.TrocoDelivery = '';
    }

    if (selectedPaymentMethod && selectedPaymentMethod.Prefixo != 'CRDE' && selectedPaymentMethod.Prefixo != 'CRCR') {
      storeOrder.CodBandeiraCartaoDelivery = '';
    }

    const currentTab = switcher.getCurrentTabIndex();

    // Refresh the content to show the newly added card
    const currentTabContent = switcher.getTabContent(currentTab);
    if (currentTabContent) {
      currentTabContent.innerHTML = '';

      currentTabContent.appendChild(currentTab === 0 ? (usaPagamentoOnline ? createOnlinePaymentContent() : createDeliveryPaymentContent()) : createDeliveryPaymentContent());
    }
  }

  function removeCurrentSelected() {
    const selected = container.querySelector('.bg-selected-green');
    if (selected) {
      selected.classList.remove('border-green-500', 'bg-selected-green');
      selected.querySelector('.check-icon')?.classList.add('oculto');
    }

    selectedPaymentMethod = null;
  }

  /**
   * Zera a escolha do "Pague pelo app". Sem isto o cartão Malga continuava
   * marcado no storeOrder depois de o cliente escolher pagar na entrega, e o
   * pedido saía como pagamento online.
   */
  function limpaCartaoOnline() {
    storeOrder.malgaCardId = '';
    storeOrder.malgaTokenId = '';
    storeOrder.hashCard = '';
    storeOrder.cartao = undefined;
  }

  function onClickPix(idFormaPagamento) {
    const sicredi = bandeiraSicredi(metodoPIXOnline)
    storeOrder.CodBandeiraCartaoDelivery = '';
    if (sicredi) {
      storeOrder.CodBandeiraCartaoDelivery = sicredi.Bandeira?.Id;
    }

    storeOrder.CodTipoPagamento = idFormaPagamento;
    storeOrder.malgaCardId = '';
    storeOrder.malgaTokenId = '';
    storeOrder.hashCard = '';
    storeOrder.cartao = undefined;
    enableSaveOrderButton();
  }

  // Return the current selected payment method from outside
  return {
    getSelectedPaymentMethod: () => selectedPaymentMethod,
    refreshPaymentCards,  // Export this method to allow refreshing from outside   
  };

  async function addNewCard(container, onCardAdded) {
    const result = await abreFormCartaoMalga();
    if (!result || !result.ok) return;

    usuario.cartoesMalga = (usuario.cartoesMalga || []).filter((card) => !card.temporary && card.cardId !== '__malga_token__');
    storeOrder.CodTipoPagamento = metodoPagamentoOnlineCredito.Id;
    storeOrder.hashCard = '';
    storeOrder.cartao = undefined;
    storeOrder.pixNaEntrega = false;

    if (result.card && result.card.cardId) {
      usuario.cartoesMalga.push({
        cardId: result.card.cardId,
        brand: result.card.brand,
        last4: result.card.last4 || '••••',
        alias: result.card.alias || '',
      });
      storeOrder.malgaCardId = result.card.cardId;
      storeOrder.malgaTokenId = '';
    } else if (result.temp && result.temp.tokenId) {
      usuario.cartoesMalga.unshift({
        cardId: '__malga_token__',
        brand: 'Malga',
        last4: 'novo',
        temporary: true,
      });
      storeOrder.malgaCardId = '';
      storeOrder.malgaTokenId = result.temp.tokenId;
      storeOrder.saveCard = false;
    }

    selectedPaymentMethod = metodoPagamentoOnlineCredito;
    enableSaveOrderButton();
    onCardAdded && onCardAdded();
    return;

    let campoEmail = '';

    if (!usuario.email) {
      campoEmail = `
        <div class="icon-input">
          <input id="card-email" class="input" type="email"
            placeholder="Email" value="${storeOrder.Email || usuario.email || ''}" required/>
          <div class="card-img">
            <i class="fa fa-envelope-o"></i>
          </div>
        </div> 
      `;
    }

    createMessageBox({
      title: 'Adicionar cartão de crédito',
      subtitle:
        'Preencha os campos abaixo para adicionar um novo cartão de crédito',
      content: `
        <div id="adicionar-cartao" class="pagamento-app-form">               
          <div class="icon-input">
            <input id="card-number" class="input" type="text" maxlength="20"
              placeholder="Número do cartão" value="${storeOrder.cartao?.numero || ''}"/>
            <div class="card-img">
              <i class="far fa-credit-card"></i>
            </div>
          </div>
  
          <div class="u-flex card-between">
            <div class="icon-input">
              <input id="card-date" class="input" type="text" placeholder="mm/aaaa" value="${storeOrder.cartao?.vencimento || ''}" required/>
              <div class="card-img">
                <i class="far fa-calendar-alt"></i>
              </div>
            </div>
  
            <div class="icon-input">
              <input id="card-cvv" class="input" type="text" placeholder="CVV" maxlength="3" value="${storeOrder.cartao?.cvv || ''}" required/>
              <div class="card-img">
                <i class="fas fa-shield-alt"></i>
              </div>
            </div>
          </div>
          
          <div class="icon-input">
            <input id="card-cpf" class="input" type="text" placeholder="CPF do titular do cartão" value="${storeOrder.cartao?.cpf || usuario.cpf || ''}" required/>
            <div class="card-img">
              <i class="far fa-id-card"></i>
            </div>
          </div>
  
          <div class="icon-input">
            <input id="card-name" class="input" type="text" placeholder="Nome do cartão" required value="${storeOrder.cartao?.nome || ''}" />
            <div class="card-img">
              <i class="far fa-user"></i>
            </div>
          </div>
  
          ${campoEmail}
  
          <label class="label-button">
            <input id="salvar-cartao" type="checkbox"/>
            <span>Salvar cartão para compras futuras</span>
          </label>
  
          <div class="oculto informar-senha">
            <div class="font-12 m-12-0">Para manter o cartão salvo, por favor, informe uma senha para sua conta</div>
            <div class="input-wrapper">
              <input id="senha-usuario" class="input" type="password" placeholder="Senha" required/>
              <input id="confirmar-senha" class="input" type="password" placeholder="Confirmar senha" required/>
            </div>
          </div>
          
          <div class="flex gap-12">
            <button id="btn-cancelar" class="btn-transparent w-100 m-t-16">Cancelar</button>
            <button id="btn-salvar-cartao" class="btn-azul w-100 m-t-16">Continuar</button>
          </div>
        </div>`,
      beforeAppend: (dialog) => {
        const inputNomeCartao = dialog.querySelector('#card-name');
        const inputNumeroCartao = dialog.querySelector('#card-number');
        const inputValidadeCartao = dialog.querySelector('#card-date');
        const inputCvvCartao = dialog.querySelector('#card-cvv');
        const inputCpfCartao = dialog.querySelector('#card-cpf');
        const inputEmail = dialog.querySelector('#card-email');
        const saveCard = dialog.querySelector('#salvar-cartao');

        const wrapperSenha = dialog.querySelector('.informar-senha');

        saveCard.addEventListener('change', () => {
          if (saveCard.checked && !usuario.temSenha) {
            wrapperSenha.classList.remove('oculto');
          } else {
            wrapperSenha.classList.add('oculto');
          }
        });

        const btnCancelar = dialog.querySelector('#btn-cancelar');
        btnCancelar.addEventListener('click', () => {
          dialog.remove();
        });

        const btnSalvarCartao = dialog.querySelector('#btn-salvar-cartao');
        btnSalvarCartao.addEventListener('click', () => {
          if (!inputNomeCartao.checkValidity()) {
            inputNomeCartao.setCustomValidity('Nome do cartão inválido');
            inputNomeCartao.reportValidity();
            return;
          }

          if (inputNumeroCartao.value.replaceAll(' ', '').length < 16) {
            inputNumeroCartao.setCustomValidity('Número do cartão inválido');
            inputNumeroCartao.reportValidity();
            return;
          }

          if (inputValidadeCartao.value.length < 7) {
            inputValidadeCartao.setCustomValidity('Data de validade inválida');
            inputValidadeCartao.reportValidity();
            return;
          }

          if (inputCvvCartao.value.length < 3) {
            inputCvvCartao.setCustomValidity('CVV inválido');
            inputCvvCartao.reportValidity();
            return;
          }

          if (inputCpfCartao.value.length < 14) {
            inputCpfCartao.setCustomValidity('CPF inválido');
            inputCpfCartao.reportValidity();
            return;
          }

          if (inputEmail && !inputEmail.checkValidity()) {
            inputEmail.setCustomValidity('Email inválido');
            inputEmail.reportValidity();
            return;
          }

          const dadosParaSalvar = {};
          if (!usuario.email && inputEmail) {
            dadosParaSalvar.email = inputEmail.value;
          }

          if (saveCard.checked && !usuario.temSenha) {
            const senha = dialog.querySelector('#senha-usuario');
            const confirmarSenha = dialog.querySelector('#confirmar-senha');

            if (senha.value.length < 6) {
              senha.setCustomValidity('Senha deve ter no mínimo 6 caracteres');
              senha.reportValidity();
              return;
            } else if (senha.value != confirmarSenha.value) {
              confirmarSenha.setCustomValidity('As senhas não conferem');
              confirmarSenha.reportValidity();
              return;
            }

            dadosParaSalvar.senha = senha.value;
            dadosParaSalvar.confirmaSenha = confirmarSenha.value;
          }

          if (Object.keys(dadosParaSalvar).length > 0) {
            alteraDadosUsuario({
              ...dadosParaSalvar,
            }).then((response) => {
              if (response.lValid) {
                salvarCartao();
              } else {
                toast(response.msg);
              }
            });
          } else {
            salvarCartao();
          }
        });

        criaMascaras();
        criaEventoLimparValidacao();

        function criaMascaras() {
          IMask(inputNomeCartao, {
            mask: /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
          });
          IMask(inputNumeroCartao, { mask: '0000 0000 0000 0000' });
          IMask(inputValidadeCartao, { mask: '00/0000' });
          IMask(inputCvvCartao, { mask: '000' });
          IMask(inputCpfCartao, { mask: '000.000.000-00' });

          inputCpfCartao.addEventListener('blur', () => {
            const valueAsString = inputCpfCartao.value.toString();
            if (valueAsString.length > 0) {
              if (!TestaCPF(valueAsString)) {
                inputCpfCartao.setCustomValidity('CPF inválido');
                inputCpfCartao.reportValidity();
              }
            }
          });

          inputNumeroCartao.addEventListener('input', () => {
            const cardType = detectCard(inputNumeroCartao.value);
            const wrapper = inputNumeroCartao.parentElement.querySelector('.card-img');
            if (cardType) {
              const img = document.createElement('img');
              img.src = `${location.origin}/images/pagamentos/${cardType}.svg`;
              img.title = cardType;

              if (wrapper) {
                wrapper.innerHTML = '';
                wrapper.appendChild(img);
              }
            } else {
              wrapper.innerHTML = '<i class="far fa-credit-card"></i>';
            }
          });

          inputNumeroCartao.addEventListener('blur', () => {
            if (
              !detectCard(inputNumeroCartao.value) &&
              inputNumeroCartao.value.toString().length > 0
            ) {
              inputNumeroCartao.setCustomValidity('Número de cartão inválido');
              inputNumeroCartao.reportValidity();
            }
          });
        }

        function criaEventoLimparValidacao() {
          const inputs = [
            inputNomeCartao,
            inputNumeroCartao,
            inputValidadeCartao,
            inputCvvCartao,
            inputCpfCartao,
            inputEmail,
          ].filter(Boolean);

          inputs.forEach((input) => {
            input.addEventListener('input', () => {
              input.setCustomValidity('');
            });
          });
        }

        function salvarCartao() {
          const [mes, ano] = inputValidadeCartao.value.split('/');
          const ultimosQuatroDigitos = inputNumeroCartao.value.replaceAll(' ', '').slice(-4);

          const cartao = {
            nome: inputNomeCartao.value,
            numero: inputNumeroCartao.value,
            cvv: inputCvvCartao.value,
            cpf: inputCpfCartao.value,
            mes,
            ano,
            vencimento: inputValidadeCartao.value,
            clienteCpf: inputCpfCartao.value,
            saveCard: saveCard.checked,
            codTipoPagamento: metodoPagamentoOnlineCredito.Id,
            email: inputEmail ? inputEmail.value : usuario.email,
          };

          storeOrder.cartao = cartao;
          storeOrder.CodTipoPagamento = metodoPagamentoOnlineCredito.Id;
          storeOrder.ClienteCpf = inputCpfCartao.value;
          storeOrder.saveCard = saveCard.checked;

          usuario.cpf = inputCpfCartao.value;

          if (inputEmail) {
            storeOrder.Email = inputEmail.value;
            usuario.email = inputEmail.value;
          }

          dialog.remove();
          enableSaveOrderButton();

          // Add card to user's cards collection
          usuario.cartoes.push({
            LastFourDigits: ultimosQuatroDigitos,
            ExpDate: cartao.mes + '/' + cartao.ano,
            HashCard: 'novo-cartao-' + ultimosQuatroDigitos,
            raw: cartao,
          });

          // Notify the component about the new card
          if (onCardAdded) {
            onCardAdded();
          }
        }
      },
    });
  }

  function showTrocoDialog(paymentMethod, paymentCard) {
    const totalPedido = parseFloat(storeOrder.valorTotal || 0) -
      parseFloat(storeOrder.ValorDesconto || 0) +
      parseFloat(storeOrder.TaxaEntrega || 0);

    createMessageBox({
      title: 'Precisa de troco para quanto?',
      content: `
        <div class="flex-column gap-16 py-16">
          <div class="font-14 mb-16">Total do pedido: ${formatMoney(totalPedido)}</div>
          
          <div class="icon-input">
            <input id="troco" class="input" type="text" placeholder="Valor do troco" value="${storeOrder.TrocoDelivery || ''}" autocomplete="off" required/>
          </div>
          
          <div class="flex gap-12 mt-16">
            <button id="cancelar" class="btn-transparent w-100">Não preciso de troco</button>
            <button id="continuar" class="btn-azul w-100">Continuar</button>
          </div>
        </div>
      `,
      beforeAppend: (dialog) => {
        const inputTroco = dialog.querySelector('#troco');
        const buttonContinuar = dialog.querySelector('#continuar');
        const buttonCancelar = dialog.querySelector('#cancelar');

        // Apply mask to the input
        IMask(inputTroco, {
          mask: 'R$ num',
          blocks: {
            num: {
              mask: Number,
              scale: 2,
              thousandsSeparator: '.',
              radixPoint: ',',
              min: 0,
              reverse: true,
              allowMinus: false,
              padFractionalZeros: true,
              lazy: false,
              placeholder: '0,00',
              currency: 'R$',
              requireDecimal: true,
              decimalSymbol: ',',
              groupSeparator: '.',
            },
          },
        });

        buttonContinuar.addEventListener('click', () => {
          const decimalValueAsString = inputTroco.value.replace(/[^0-9,]/g, '');
          const floatValue = parseFloat(decimalValueAsString.replace(',', '.') || '0');

          if (floatValue < totalPedido) {
            // Show error message
            toast('O valor para troco deve ser maior que o valor total do pedido.');
            return;
          }

          storeOrder.TrocoDelivery = decimalValueAsString;

          dialog.remove();
          enableSaveOrderButton();

          refreshPaymentCards();
        });

        buttonCancelar.addEventListener('click', () => {
          storeOrder.TrocoDelivery = '';

          dialog.remove();
          enableSaveOrderButton();

          refreshPaymentCards();
        });
      },
    });
  }


  function showBrandsDialog(method, paymentCard) {
    if (!method.Bandeiras || method.Bandeiras.length === 0) {
      // If no brands available, just select the payment method
      paymentCard.setSelected(true);
      selectedPaymentMethod = method;
      storeOrder.CodTipoPagamento = method.Id;
      storeOrder.CodBandeiraCartaoDelivery = '';
      storeOrder.pixNaEntrega = method.Prefixo == "PIX";
      limpaCartaoOnline();
      enableSaveOrderButton();
      return;
    }

    createMessageBox({
      title: `Selecione a bandeira do ${method.Descricao}`,
      content: `
      <div class="flex flex-column gap-16 justify-center py-16">
        ${method.Bandeiras.map(band => {
        const brandInfo = band.Bandeira;
        return `
            <div class="card-brand" data-brand-id="${brandInfo.Id}">
              <div class="bg-white border-1 border-gray-100 flex-center flex-start gap-8 p-12 rounded-lg shadow-sm w-100">
                <img 
                    style="width: 22px; height: 22px;"
                    class="object-fit-contain w-h-40" 
                    src="${location.origin}/images/pagamentos/${brandInfo.StrTipoBandeira.toLowerCase()}.svg" 
                    alt="${brandInfo.Descricao}" 
                    onerror="this.src='${location.origin}/images/pagamentos/outros.svg'"
                  >
                <span class="font-12 text-center">${brandInfo.Descricao}</span>
              </div>
            </div>
          `;
      }).join('')}
      </div>
      <div class="flex justify-center mt-16">
        <button id="cancel-brand-selection" class="btn-transparent">Cancelar</button>
      </div>
    `,
      beforeAppend: (dialog) => {
        const brandCards = dialog.querySelectorAll('.card-brand');
        brandCards.forEach(card => {
          card.addEventListener('click', () => {
            const brandId = card.dataset.brandId;
            // Set the selected payment method
            removeCurrentSelected();

            paymentCard.setSelected(true);
            selectedPaymentMethod = method;
            storeOrder.CodTipoPagamento = method.Id;
            storeOrder.CodBandeiraCartaoDelivery = brandId;
            storeOrder.pixNaEntrega = method.Prefixo == "PIX";
            limpaCartaoOnline();
            enableSaveOrderButton();
            dialog.remove();


            refreshPaymentCards();

          });

          // Add ripple effect
          ripple(card);
        });

        const cancelButton = dialog.querySelector('#cancel-brand-selection');
        cancelButton.addEventListener('click', () => {
          dialog.remove();
        });

        // Apply some additional styles for better UX
        const style = document.createElement('style');
        style.textContent = `
        .card-brand {
          cursor: pointer;
          transition: transform 0.2s;
        }
        .card-brand:hover {
          transform: translateY(-4px);
        }
        .brand-card {
          width: 90px;
          height: 90px;
        }
      `;
        dialog.appendChild(style);
      }
    });
  }
}

function generateCardSVG(index = 0) {
  const palette = {
    '0': {
      main: '#9BC0FA',
      light: '#0965EF',
    },
    '1': {
      main: '#F59CB1',
      light: '#E50E3F',
    },
    '2': {
      main: '#FFB783',
      light: '#FF8834',
    },
    '3': {
      main: '#C7ABE9',
      light: '#7532C8',
    },
    '4': {
      main: '#AFECB6',
      light: '#3FCF4E',
    },
    '5': {
      main: '#FFB783',
      light: '#FF8834',
    },
  };

  const color = palette[index];

  return `
  <svg class="overflow-hidden rounded-sm" width="23" height="17" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="21" height="5" fill="${color.light}"/>
    <rect y="5" width="21" height="10" fill="${color.main}"/>
  </svg>
  `;
}

export function exibeTelaVoucher() {
  createMessageBox({
    content: `
      <div class="flex flex-center flex-column gap-20 text-center">
        <div>
          <div class="font-16 font-500 m-t-4">Código do Voucher</div>
          <div class="font-13 font-normal text-gray-300">Digite o código do seu voucher para aplicar o desconto</div>
        </div>
        
        <div class="w-100">
          <input 
            type="text" 
            id="codigo-voucher" 
            placeholder="Digite o código do voucher"
            class="w-100 p-12 border border-gray-200 rounded"
            style="padding: 12px; border: 1px solid #e5e5e5; border-radius: 4px; width: 100%; font-size: 14px;"
          />
          <span id="erro-voucher" class="font-12 text-red-500 empty-hiddem"></span>
        </div>
        
        <div class="flex gap-12 w-100">
          <button class="btn-transparent w-100" id="btn-cancelar-voucher">Cancelar</button>    
          <button class="btn-azul w-100" id="btn-validar-voucher">Validar</button>                                                    
        </div>
      </div>
    `,
    beforeAppend: (wrapper) => {
      const inputVoucher = select('#codigo-voucher', wrapper);
      const btnCancelar = select('#btn-cancelar-voucher', wrapper);
      const btnValidar = select('#btn-validar-voucher', wrapper);
      const erroVoucher = select('#erro-voucher', wrapper);

      // Foco no input quando a tela abrir
      setTimeout(() => {
        inputVoucher.focus();
      }, 100);

      // Evento do botão cancelar
      btnCancelar.addEventListener('click', () => {
        wrapper.remove();
      });

      // Evento do botão validar
      btnValidar.addEventListener('click', () => {
        const loader = buttonLoader(btnValidar);

        erroVoucher.textContent = ''; // Limpa mensagem de erro
        const codigoVoucher = inputVoucher.value.trim();

        if (!codigoVoucher) {
          // Destacar o campo se estiver vazio
          inputVoucher.style.borderColor = '#ff4444';
          inputVoucher.focus();
          erroVoucher.textContent = 'Por favor, informe o código do voucher.';
          return;
        }

        axios.get(getUrlAction('Pedido', 'ValidaVoucher'), {
          params: {
            strVoucher: codigoVoucher,
          },
        }).then(({ data }) => {
          data = JSON.parse(data);
          if (data.lValid) {

            if (data.saldo > storeOrder.valorTotal) {
              // Se o voucher for válido, aplica o desconto
              storeOrder.CodigoVoucher = codigoVoucher;

              // Fecha a tela de voucher
              wrapper.remove();

              toast('Voucher aplicado com sucesso!');

              const btn = select("#salva-pedido")
              if (btn) {
                btn.click();
              }
            } else {
              // Se o voucher não for suficiente, exibe mensagem de erro
              inputVoucher.style.borderColor = '#ff4444'; // Destaca o campo em vermelho
              inputVoucher.focus(); // Foca no campo novamente
              erroVoucher.textContent = `O valor do voucher é insuficiente. Saldo: ${formatMoney(data.saldo)}.`;
              return;
            }


          } else {
            inputVoucher.style.borderColor = '#ff4444'; // Destaca o campo em vermelho
            inputVoucher.focus(); // Foca no campo novamente
            erroVoucher.textContent = data.cErro || data.msg || 'Código do voucher inválido.';
            return;
          }
        }).catch((error) => {
          console.error('Erro ao validar voucher:', error);
          inputVoucher.style.borderColor = '#ff4444'; // Destaca o campo em vermelho
          inputVoucher.focus(); // Foca no campo novamente
          erroVoucher.textContent = 'Erro ao validar voucher. Tente novamente mais tarde.';
        }).finally(() => {
          loader.stop(); // Remove o loader do botão
        })

      });

      // Permitir validação ao pressionar Enter
      inputVoucher.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          btnValidar.click();
        }
      });

      // Remover destaque vermelho quando o usuário digitar
      inputVoucher.addEventListener('input', () => {
        inputVoucher.style.borderColor = '#e5e5e5';
      });
    },
  });
}

